import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GalleryService } from '../../providers/gallery.service';
import { LoggerService } from '../../providers/logger.service';

@Component({
  selector: 'app-redirect-dropbox',
  templateUrl: './redirect-dropbox.component.html',
  styleUrls: ['./redirect-dropbox.component.css']
})
export class RedirectDropboxComponent implements OnInit {

  action: any; //$routeParams['action'];

  constructor(private logger: LoggerService,
    private route: ActivatedRoute,
    private router: Router,
    private gallery: GalleryService) { }

  ngOnInit(): void {
    this.action = this.route.snapshot.params['action'];
    this.activate();
  }

  activate() {
    try {
      if (this.action === 'login')
        this.doLogin();
      else
        this.doLoginCode();
    } catch (e) {
      this.logger.write2log('redirect-dropbox-activate', e.message, 'E');
    }
  }

  doLogin() {
    try {
      var fileId = this.route.snapshot.params['param1'];
      var params = null;
      if (fileId !== null && fileId !== undefined) {
        params = 'file_id=' + encodeURIComponent(fileId)
      }

      this.gallery.doDropboxLoginAction('login', params).then(
        (data) => {
          try {
            if (data['url']) {
              window.location.href = data['url'];
            } else {
              console.log('DROPBOX-LOGIN: Got invalid response.', data);
              this.logger.write2log('redirect-dropbox-dologin.2', 'Got invalid response.', 'E');
              this.router.navigate(["/gallery/"], {});
            }
          } catch (e) {
            this.logger.write2log('redirect-dropbox-dologin.3', e.message, 'E');
            this.router.navigate(["/gallery/"], {});
          }
        });

    } catch (e) {
      this.logger.write2log('redirect-dropbox-dologin', e.message, 'E');
    }
  }

  doLoginCode() {
    try {
      var code = this.route.snapshot.params['param1'];
      var state = this.route.snapshot.params['param2'];
      this.gallery.doDropboxLoginAction('logincode',
        'code=' + encodeURIComponent(code) +
        '&state=' + encodeURIComponent(state)
      ).then(
        (data) => {
          try {
            if (data['url']) {
              this.router.navigate([data['url']], {});
            } else {
              console.log('DROPBOX-CODE: Got invalid response.', data);
              this.logger.write2log('redirect-dropbox-dologincode.2', 'Got invalid response.', 'E');
              this.router.navigate(["/gallery/"], {});
            }
          } catch (e) {
            this.logger.write2log('redirect-dropbox-dologincode.3', e.message, 'E');
            this.router.navigate(["/gallery/"], {});
          }
        });

    } catch (e) {
      this.logger.write2log('redirect-dropbox-dologincode', e.message, 'E');
    }
  }

}
